import { eng } from "../assets";

const teamInfo = [
    {
        image: eng,
        title: "Eng. Isaac Benard",
        decs: "Managing Director",
    },  
];
export default teamInfo
  